import IconGlobe from '../../../../images/illustrated/globe.svg';
import IconLeaf from '../../../../images/illustrated/leaf-co2.svg';
import IconTravel from '../../../../images/illustrated/travel.svg';
import ImageInsideTrain from '../../../../images/travelers/cards/traveler-inside-train-1x.webp';
import ImageInsideTrain2x from '../../../../images/travelers/cards/traveler-inside-train-2x.webp';
import ImageInsideTrain3x from '../../../../images/travelers/cards/traveler-inside-train-3x.webp';
import ImageOutsideTrain from '../../../../images/travelers/cards/traveler-outside-train-1x.webp';
import ImageOutsideTrain2x from '../../../../images/travelers/cards/traveler-outside-train-2x.webp';
import ImageOutsideTrain3x from '../../../../images/travelers/cards/traveler-outside-train-3x.webp';

interface IGalleryImage {
  src: string;
  src2x: string;
  src3x: string;
  altMessage: string;
}

export const GALLERY_IMAGES: IGalleryImage[] = [
  {
    src: ImageInsideTrain,
    src2x: ImageInsideTrain2x,
    src3x: ImageInsideTrain3x,
    altMessage: 'picture of a person inside a train',
  },
  {
    src: ImageOutsideTrain,
    src2x: ImageOutsideTrain2x,
    src3x: ImageOutsideTrain3x,
    altMessage: 'picture of a person outside a train',
  },
];

interface IBullet {
  src: string;
  altMessage: string;
  message: string;
}

export const CONCEPT_BULLETS: IBullet[] = [
  {
    src: IconGlobe,
    message: 'conceptBulletTravel',
    altMessage: 'Globe icon',
  },
  {
    src: IconLeaf,
    message: 'conceptBulletLowCarbon',
    altMessage: 'Leaf icon',
  },
  {
    src: IconTravel,
    message: 'conceptBulletIsolatedAreas',
    altMessage: 'Travel icon',
  },
];
